// extracted by mini-css-extract-plugin
export default {"title":"FormDescription_title__K6+uQ","boldTitle":"FormDescription_boldTitle__xUOcS","descriptionFS":"FormDescription_descriptionFS__mk0fn"};